// The theme is the system's unless the person chose one. The choice lives in
// this browser only; it is a preference of the eyes, not of the tenant.
export type Theme = 'system' | 'light' | 'dark'

export const THEME_KEY = 'tprm.theme'

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(THEME_KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch {
    return 'system'
  }
}

export function applyTheme(t: Theme): void {
  const el = document.documentElement
  if (t === 'system') delete el.dataset.theme
  else el.dataset.theme = t
  try {
    if (t === 'system') localStorage.removeItem(THEME_KEY)
    else localStorage.setItem(THEME_KEY, t)
  } catch {
    // A browser that refuses storage still gets the theme for this visit.
  }
}
